import { jsx } from 'react/jsx-runtime';

function Footer({ children }) {
    return (jsx("div", { className: "modal--footer", children: children }));
}
Footer.defaultProps = {
    children: null,
};

export { Footer as default };
